var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRailDocsFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H24V24H0z",
    transform: "translate(-103.999 -1362.001) translate(103.999 1362.001)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.523 6.677h4.992a.314.314 0 0 0 .235-.523L26.523.927a.314.314 0 0 0-.523.22v5.007a.523.523 0 0 0 .523.523z",
    transform: "translate(-103.999 -1362.001) translate(106.068 1362.5) translate(-12.409 -.404)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 7.841V.523A.523.523 0 0 0 10.977 0H.523A.523.523 0 0 0 0 .523v21.954A.523.523 0 0 0 .523 23h18.818a.523.523 0 0 0 .523-.523V8.886a.523.523 0 0 0-.523-.523h-7.318a.523.523 0 0 1-.523-.522z",
    transform: "translate(-103.999 -1362.001) translate(106.068 1362.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRailDocsFilled);
export default __webpack_public_path__ + "static/media/rail-docs-filled.0b3281151d4beb7cdc353269600d967e.svg";
export { ForwardRef as ReactComponent };